<div class="table-container">
    <table *ngIf="excelData">
        <thead>
            <tr>
                <th class="user-cell">
                    <span class="fw-semibold">{{ currentUser.username | uppercase }}</span>
                </th>
                <th colspan="3" class="title-cell">
                    {{ excelData[headerTitleRowIndex][1] }}
                </th>
                <th colspan="4" class="date-cell">
                    {{ excelData[headerTitleRowIndex][4] }}
                </th>
            </tr>

            <tr class="header-row">
                <th *ngFor="let header of excelData[columnsHeaderRowIndex]">
                    {{ header }}
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let row of excelData.slice(dataStartIndex); let i = index"
                [class.selected]="selectedRowIndex === i" (click)="selectRow(i)">

                <!-- Groupe(s) : fusionnée sur les lignes consécutives identiques -->
                <td *ngIf="rowspans[i] > 0" [attr.rowspan]="rowspans[i]" class="header-row">
                    {{ row[COL_GROUPE] }}
                </td>

                <td class="truncate-cell">{{ row[COL_VEHICULE] }}</td>
                <td class="truncate-cell">{{ row[COL_CHAUFFEUR] }}</td>
                <td class="truncate-cell">{{ row[COL_LIEU] }}</td>

                <!-- LatLng : lien cliquable vers Google Maps -->
                <td class="truncate-cell" style="min-width: 220px !important; max-width: none !important; white-space: nowrap !important;">
                    <a *ngIf="getMapsUrl(row[COL_LATLNG]) as mapsUrl"
                       [href]="mapsUrl"
                       target="_blank"

                       rel="noopener noreferrer">
                        {{ row[COL_LATLNG] }}
                    </a>
                    <span *ngIf="!getMapsUrl(row[COL_LATLNG])">{{ row[COL_LATLNG] }}</span>
                </td>

                <td class="truncate-cell">{{ row[COL_DATE_ARRET] }}</td>
                <td class="truncate-cell">{{ row[COL_TEMPS_ARRET] }}</td>
                <td class="truncate-cell">{{ row[COL_DEPASSEMENT] }}</td>
            </tr>
        </tbody>
    </table>
</div>